import { SquadsRedirect } from 'components/rivals/squads/SquadsRedirect';

const MySquadPage = () => {
  return <SquadsRedirect />;
};
export default MySquadPage;
